/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_ChestInputs */

const en_us2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chest`)
};

const pt_br2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peito`)
};

const es_419_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pecho`)
};

const pt_pt2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peito`)
};

const fr_fr2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poitrine`)
};

const de_de2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brust`)
};

const it_it2_profile_editors_pain_area_chest = /** @type {(inputs: Profile_Editors_Pain_Area_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petto`)
};

/**
* | output |
* | --- |
* | "Chest" |
*
* @param {Profile_Editors_Pain_Area_ChestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_chest = /** @type {((inputs?: Profile_Editors_Pain_Area_ChestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_ChestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_chest(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_chest(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_chest(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_chest(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_chest(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_chest(inputs)
	return en_us2_profile_editors_pain_area_chest(inputs)
});
export { profile_editors_pain_area_chest as "profile-editors.pain_area_chest" }